import React from 'react';
import UnifiedStationHeader from './UnifiedStationHeader';

// Type definitions for backward compatibility
interface CurrentRoutine {
  routineNumber: number | string;
  name: string;
  performerName?: string;
  studioCode?: string;
  studioName?: string;
  category?: string;
  division?: string;
  type?: string;
  ageGroup?: string;
  [key: string]: any;
}

interface CurrentRoutineHeaderProps {
  currentRoutine?: CurrentRoutine | null;
  canNavigatePrevious?: boolean;
  canNavigateNext?: boolean;
  onNavigatePrevious?: () => void;
  onNavigateNext?: () => void;
  timerProgress?: number;
  className?: string;
  // Legacy props for backward compatibility
  isDarkMode?: boolean;
}

/**
 * CurrentRoutineHeader Component (Legacy Wrapper)
 * 
 * This is a backward compatibility wrapper around UnifiedStationHeader.
 * For new implementations, use UnifiedStationHeader directly with stationType="tabulator".
 * 
 * @deprecated Use UnifiedStationHeader with stationType prop instead
 */
const CurrentRoutineHeader: React.FC<CurrentRoutineHeaderProps> = (props) => {
  // Extract legacy props and pass through to UnifiedStationHeader
  const { isDarkMode, ...otherProps } = props;

  return (
    <UnifiedStationHeader
      stationType="tabulator"
      tabulatorTitle="ROUTINE HEADER"
      tabulatorSubtitle="Current Performance"
      {...otherProps}
    />
  );
};

export default CurrentRoutineHeader;
